import { cloneDeep } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons, routerQueryReplace } from '@/utils'

import squircle from '@/components/icon/squircle'
import info from '@/components/info'
import ExpandArrow from '@/components/misc/ExpandArrow'
import preloader from '@/components/preloader'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}

function renderMenuItem(h, options, item) {
  const { key, icon } = item

  return h(
    components['list-item'],
    {
      props: {
        icon: icon || icons.settings,
        label: this.getTranslate(`${options.serviceName}.titles.${key}`),
        active: this.settingKey === key,
        dense: true,
        link: true
      },
      on: {
        click: () => {
          const { query } = this.$route
          if (query && (!query.settingKey || query.settingKey !== key)) {
            routerQueryReplace({ settingKey: key })
          }
        }
      }
    }
  )
}
function renderMenuItems(h, options) {
  let items
  if (Array.isArray(this.schema)) {
    items = this.schema
  } else {
    items = []
  }

  return items.map(item => {
    return renderMenuItem.call(this, h, options, item)
  })
}
function renderMenu(h, options) {
  if (this.viewport.size.width > 1024) {
    return h(
      components.list,
      {
        props: {
          dense: true,
          rounded: true,
          outline: true
        }
      },
      [ renderMenuItems.call(this, h, options) ]
    )
  }
}

function renderIcon(h, icon) {
  return h(
    squircle,
    {
      props: {
        icon: icon || icons.settings,
        color: Colors.grey
      }
    }
  )
}

function renderChild(h, path) {
  if (path) {
    if (path === '__separator__') {
      return h(
        components.divider,
        {
          class: 'mt-2 mb-2'
        }
      )
    }
    try {
      const componentDefinition = this.getComponentDefinition(path)
      if (componentDefinition) {
        return h(
          componentDefinition,
          {
            props: {
              value: cloneDeep(this.settings[path]),
              settings: this.settings
            },
            key: path,
            on: {
              input: (event, childPath) => {
                this.inputEventHandler(event, childPath || path)
              }
            }
          }
        )
      }
    } catch (error) {
      return h(
        info,
        {
          props: {
            value: this.getTranslate('settings.errors.componentNotFound', { key: path }),
            color: Colors.error
          }
        }
      )
    }
  }
}
function renderChildren(h, children) {
  return h(
    'div',
    {
      class: 'settings-item__children'
    },
    [
      children.map(child => {
        return renderChild.call(this, h, child)
      })
    ]
  )
}
function renderItemByViewport(h, options, item) {
  const { key, icon, children } = item
  if (this.viewport.size.width > 1024) {
    if (this.settingKey === key) {
      return renderChildren.call(this, h, children)
    }
  } else {
    return h(
      components['expansion-panel'],
      {
        scopedSlots: {
          header: ({ expanded }) => {
            return h(
              'div',
              {
                class: 'settings-item__header'
              },
              [
                renderIcon.call(this, h, icon),
                this.getTranslate(`${options.serviceName}.titles.${key}`),
                h('div', { class: 'ff' }),
                h(ExpandArrow, { props: { expanded } })
              ]
            )
          }
        }
      },
      [ renderChildren.call(this, h, children) ]
    )
  }
}
function renderItems(h, options) {
  return this.schema.map(item => {
    return renderItemByViewport.call(this, h, options, item)
  })
}
function renderBody(h, options) {
  if (this.settings !== undefined) {
    return h(
      this.bodyParams.component,
      { props: this.bodyParams.props },
      [ renderItems.call(this, h, options) ]
    )
  }
}

export default function(h, options) {
  if (this.loading.find) {
    return renderPreloader.call(this, h)
  }

  return h(
    'div',
    {
      class: 'settings'
    },
    [
      renderMenu.call(this, h, options),
      renderBody.call(this, h, options)
    ]
  )
}
